import { HOST_IDENTITY } from '../constants';

// Display labels for participants. Calls are two-party, so the screen only needs two generic labels:
// the host session is "Host" and anyone else (the guest on the link) is "Guest". Identities themselves
// never change (the host-disconnect rule and the recording channel order key on them), so only what is
// shown on screen goes through here. How real names appear in transcripts is a separate decision.

/** The label to show for an identity; empty until the identity is known. */
export function participantLabel(identity: string): string {
  if (!identity) {
    return '';
  }
  return identity === HOST_IDENTITY ? 'Host' : 'Guest';
}
